export default __webpack_public_path__ + "static/media/P2.b448d0e8.png";